import { api } from "@/lib/api/api";
import { args } from "@/lib/args/args";
import { expectShape } from "@/lib/expect/expect-shape";
import { is } from "@/lib/is/is";
import type { ParsedArgs } from "@/lib/parsed/parsed-args";

/**
 * Reads a catalog list endpoint: no flags accepted, the response shape checked
 * before anything renders it. Generic in the payload so each command keeps its
 * own contract from `ApiOutputs` and only names the array it expects.
 */
export async function readCatalogList<T>(
  parsed: ParsedArgs,
  path: string,
  field: string,
): Promise<T> {
  args.expect(parsed, {});
  return expectShape<T>(await api(path), `GET ${path}`, { [field]: is.array });
}
